"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";
import { useEcommerce } from "../EcommerceProvider/EcommerceProvider";

export default function QuickLinks() {
  const t = useTranslations("QuickLinks");
  const ecommerce = useEcommerce();

  const quickLinks = [
    {
      id: 1,
      labelKey: "privacyPolicy",
      href: "/privacy-policy",
    },
    {
      id: 2,
      labelKey: "returnsPolicy",
      href: "/returns-policy",
    },
    {
      id: 3,
      labelKey: "termsOfUse",
      href: "/terms",
    },
    {
      id: 4,
      labelKey: "faq",
      href: "/faq",
    },
    {
      id: 5,
      labelKey: "contact",
      href: "/contact",
    },
  ];

  return (
    <div className="w-full sm:w-auto">
      <h2 className="mb-7.5 text-custom-1 font-medium text-dark">
        {t("title")}
      </h2>

      <ul className="flex flex-col gap-3">
        {quickLinks.map((link) => (
          <li key={link.id}>
            <Link
              className="ease-out duration-200 hover:text-blue"
              href={link.href}
            >
              {t(link.labelKey)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
